/**
 * @generated SignedSource<<0787388ca547f7cadddbca858ac05455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSubmissionEnd_UserFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PrivateAddressDialog_UserFragment">;
  readonly " $fragmentType": "ContentSubmissionEnd_UserFragment";
};
export type ContentSubmissionEnd_UserFragment$key = {
  readonly " $data"?: ContentSubmissionEnd_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionEnd_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentSubmissionEnd_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PrivateAddressDialog_UserFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "724fc10c0a66c220397f8f647399c0d8";

export default node;
